<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Button from "@/components/atoms/button";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import StateOverlay from "@/components/molecules/state-overlay";
import Titre from "@/components/atoms/titre";

export default {
  name: "ListesDeCoursesSupprimer",
  components: {
    Popin,
    Icon,
    Badge,
    Button,
    List,
    ListItem,
    StateOverlay,
    Titre
  },
  props: {
    listesToDelete: {
      type: Array,
      required: false,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["confirmDelete"],
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    aria-label="Confirmer la suppression de liste"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <StateOverlay
      overlay
      :is-loading="isLoading"
    >
      <div class="u-text-center">
        <Badge
          variant="white"
          circle
          size="xlg"
        >
          <Icon
            name="alert-circle"
            variant="primary"
            size="lg"
          />
        </Badge>
        <Titre
          tag="h1"
          variant="primary"
          size="md"
          class="u-mt-xs u-mb-md"
        >
          Confirmer la suppression de liste
        </Titre>
        <p class="u-font-15 u-text-left u-mb-sm">
          Vous souhaitez supprimer :
        </p>
        <List class="u-font-500 u-font-15 u-text-left">
          <ListItem
            v-for="liste in listesToDelete"
            :key="liste.id"
          >
            {{ liste.attributes.titre }}
          </ListItem>
        </List>

        <Button
          variant="primary"
          radius="full"
          size="md"
          class="u-mt-lg"
          @click="$emit('confirmDelete')"
        >
          Oui je supprime
        </Button>
      </div>
    </StateOverlay>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
